import {
  BrowserMatcher,
  DeviceMatcher,
  DomainMatcher,
  InstantConfigInterpreter,
  InstantConfigLoader,
  InstantConfigOverrider,
  InstantConfigValue,
  RegionMatcher,
} from "@wikia/instant-config-loader";
import { SettingsRepositoryCookieImpl } from "./settings-repository-cookie-impl";
import { GeoData, QueryString } from "@identity/utils";
import { CommunicationService } from "../CommunicationService";

export async function loadInstantConfig(
  communicationService: CommunicationService,
  cookiesManager: CookiesManager,
  window: Window,
  appName: string,
  browser: string,
  deviceType: string,
  geo: GeoData,
  instantConfigEndpoint: string,
  globals: Dictionary = {},
  env?: string,
): Promise<Record<string, InstantConfigValue>> {
  const instantConfigFallbackEndpoint = `https://script.wikia.nocookie.net/fandom-ae-assets/icbm/${
    env ?? "prod"
  }/icbm_state_${appName}.json`;
  const instantConfigLoader = new InstantConfigLoader({
    appName,
    instantConfigEndpoint,
    instantConfigFallbackEndpoint,
    compact: true,
  });
  const settingsRepository = new SettingsRepositoryCookieImpl(
    cookiesManager,
    communicationService,
    window,
  );
  const instantConfigInterpreter = new InstantConfigInterpreter(
    new BrowserMatcher(browser),
    new DeviceMatcher(deviceType),
    new DomainMatcher(),
    new RegionMatcher(geo),
    settingsRepository,
  );

  let config = await instantConfigLoader.getConfig();
  config = new InstantConfigOverrider().override(
    QueryString.getURLSearchParams(),
    config,
  );
  const interpreter = instantConfigInterpreter.init(config, globals);
  return interpreter.getValues();
}
